/* storybook-check-ignore */
export {
  default as default,
  getServerSideProps,
} from '../../../../components/exclusives/gallery/GalleryMarketPage';
